<template>
    <div class="text-center pt-4">
        <button class="btn btn-blue bg-fully uppercase text-[12px] lg:text-[14px] px-16 font-bold"
                @click="handlerLogin">
            Sign In
        </button>

        <div class="text-center pt-4 font-semibold">
            New customer?
            <span class="text-primary font-semibold cursor-pointer hover:underline"
                  @click="handlerRegister">
                    Register here.
                </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "who-you-are",
    props: {
        tempIdList: {
            type: String
        }
    },
    methods: {
        handlerLogin() {
            if (this.tempIdList) {
                window.location.href = `/count/create/${this.tempIdList}?_source=who_you_are&redirectto=${this.$widgetConfig.authUrls.login}`;
                return;
            }
            window.location.href = this.$widgetConfig.authUrls.login;
        },
        handlerRegister() {
            if (this.tempIdList) {
                window.location.href = `/count/create/${this.tempIdList}?_source=who_you_are&redirectto=${this.$widgetConfig.authUrls.registration}`;
                return;
            }
            window.location.href = this.$widgetConfig.authUrls.registration;
        }
    }
};
</script>
